import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import ArticleCard from '@/components/base/ArticleCard';
import ScrollToTop from '@/components/base/ScrollToTop';
import { articles, categories, siteInfo } from '@/mocks/articles';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const [activeCategory, setActiveCategory] = useState(slug || 'platform-recommend');

  useEffect(() => {
    if (slug) setActiveCategory(slug);
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [slug]);

  const category = categories.find((c) => c.slug === activeCategory);
  const categoryArticles = articles.filter((a) => a.category === activeCategory);

  useEffect(() => {
    if (category) {
      document.title = `${category.name} | ${siteInfo.name}`;
    }
  }, [category]);

  return (
    <>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <main className="flex-1 pt-16">
          <div className="bg-background-100 border-b border-background-200/70">
            <div className="max-w-7xl mx-auto px-4 md:px-6">
              <Breadcrumb items={[
                { label: '首页', path: '/' },
                { label: category?.name || '分类' },
              ]} />
              <div className="pb-8">
                <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
                  {category?.name || '分类列表'}
                </h1>
                <p className="text-sm text-foreground-500">{category?.description}</p>
              </div>
            </div>
          </div>

          <div className="max-w-7xl mx-auto px-4 md:px-6 py-6">
            <div className="flex items-center gap-2 flex-wrap mb-8">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all cursor-pointer ${
                    activeCategory === cat.slug
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-800'
                  }`}
                >
                  <i className={`${cat.icon} mr-1.5 w-4 h-4 inline-flex items-center justify-center align-middle`}></i>
                  {cat.name}
                </Link>
              ))}
            </div>

            {categoryArticles.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
                {categoryArticles.map((article) => (
                  <ArticleCard key={article.slug} {...article} />
                ))}
              </div>
            ) : (
              <div className="text-center py-16">
                <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-background-100 rounded-full">
                  <i className="ri-inbox-line text-2xl text-foreground-400 w-6 h-6 flex items-center justify-center"></i>
                </div>
                <p className="text-foreground-500 text-sm">该分类暂无文章</p>
              </div>
            )}
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}